module.exports = __webpack_public_path__ + "img/pepe-sad.96fe0736.png";